<div class="center-stage">
    <h1>Item Not Found</h1>
    <p class="lead">This item was not found or has been assigned to someone else.</p>
  </div>
